function handleSpecificScripts() {
  const tipsodd = document.querySelectorAll('.gtm-tips')
  if (tipsodd) {
    tipsodd.forEach((odd) => {
      if (odd.childElementCount === 1) {
        odd.classList.add('one-odd')
      } else if (odd.childElementCount === 3) {
        const classesToAdd = ['multiple-odd', 'three-odd']
        odd.classList.add(...classesToAdd)
      } else if (odd.childElementCount > 1) {
        odd.classList.add('multiple-odd')
      }
    })
  }
}

if (document.readyState !== 'loading') {
  handleSpecificScripts()
} else {
  document.addEventListener('DOMContentLoaded', handleSpecificScripts)
}
